//CRN_20251218 - ⚠️ ngOnInit() called for components/directives & not services ⚠️

import { eSimApiPaths } from 'src/app/core/consts';
import { EncryptAesClientSideForWeb } from 'src/app/core/encryption';
import { environment } from 'src/environments/environment';
import { ExceptionsService } from './exceptions-service';
import { HttpClientService } from './http-client-service';
import { Injectable } from '@angular/core';
import { Observable, of, ReplaySubject, switchMap } from 'rxjs';
import { StringResultDTO } from 'src/app/core/interfaces/general/string-result';

@Injectable({ providedIn: 'root' })

export class EncryptionService {

  private configLoaded$: ReplaySubject<void>=new ReplaySubject<void>(1);

  //CRN_20260123 - These are set in AppModule.loadConfigSystem()
  public serverSideEncryption         : boolean=false;
  public serverSideEncryptionDashboard: boolean=false;
  public serverSideEncryptionWidgets  : boolean=false;

  constructor(
    private exceptionsService: ExceptionsService,
    private httpClientService: HttpClientService
  ) { }

  public encrypt_AesServerSideForWeb(plainText: string, serverSideEncryption: boolean=false): Observable<StringResultDTO> {
    try {
      //CRN_20260529 - Wait for loadConfigSystem() to set this.serverSideEncryption
      return this.configLoaded$.pipe(
        switchMap(() => {
          const hasValue=plainText!=undefined && String(plainText).length>0;

          if (this.serverSideEncryption && serverSideEncryption && hasValue)
            return this.httpClientService.post(environment.eSimApi
                                               + eSimApiPaths.Crypto
                                               + "/"
                                               + eSimApiPaths.CryptoEncryptAesServerSideForWeb
                                               + "?serverSideEncryption=" + serverSideEncryption,
                                               { objectEncSS: String(plainText) });

          const clientSideResult: StringResultDTO={ result: EncryptAesClientSideForWeb(plainText) };

          return of(clientSideResult);
        })
      );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public markConfigLoaded(): void {
    try {
      this.configLoaded$.next();
      this.configLoaded$.complete();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
}
